const hcmWardMappings = {
  "Quận Gò Vấp": {
    "Phường 12": [
      "Phường An Hội Tây"
    ],
    "Phường 14": [
      "Phường An Hội Tây"
    ],
    "Phường 15": [
      "Phường An Hội Đông"
    ],
    "Phường 16": [
      "Phường An Hội Đông"
    ],
    "Phường 5": [
      "Phường An Nhơn"
    ],
    "Phường 6": [
      "Phường An Nhơn"
    ],
    "Phường 10": [
      "Phường Gò Vấp"
    ],
    "Phường 17": [
      "Phường Gò Vấp"
    ],
    "Phường 1": [
      "Phường Hạnh Thông"
    ],
    "Phường 3": [
      "Phường Hạnh Thông"
    ],
    "Phường 8": [
      "Phường Thông Tây Hội"
    ],
    "Phường 11": [
      "Phường Thông Tây Hội"
    ],
    "Phường 13": [
      "Phường An Hội Tây",
      "Phường An Hội Đông"
    ],
    "Phường 4": [
      "Phường Hạnh Thông"
    ],
    "Phường 7": [
      "Phường Hạnh Thông"
    ],
    "Phường 9": [
      "Phường Thông Tây Hội"
    ]
  },
  "Quận Bình Tân": {
    "Phường An Lạc": [
      "Phường An Lạc"
    ],
    "Phường An Lạc A": [
      "Phường An Lạc"
    ],
    "Phường Bình Trị Đông B": [
      "Phường An Lạc"
    ],
    "Phường Bình Hưng Hòa": [
      "Phường Bình Hưng Hòa"
    ],
    "Phường Bình Hưng Hoà A": [
      "Phường Bình Hưng Hòa"
    ],
    "Phường Bình Trị Đông": [
      "Phường Bình Trị Đông"
    ],
    "Phường Bình Trị Đông A": [
      "Phường Bình Trị Đông"
    ],
    "Phường Bình Hưng Hoà B": [
      "Phường Bình Tân"
    ],
    "Phường Tân Tạo A": [
      "Phường Tân Tạo"
    ],
    "Phường Tân Tạo": [
      "Phường Tân Tạo"
    ]
  },
  "Quận Tân Bình": {
    "Phường 10": [
      "Phường Bảy Hiền"
    ],
    "Phường 11": [
      "Phường Bảy Hiền"
    ],
    "Phường 12": [
      "Phường Bảy Hiền"
    ],
    "Phường 13": [
      "Phường Tân Bình"
    ],
    "Phường 14": [
      "Phường Tân Bình"
    ],
    "Phường 6": [
      "Phường Tân Hòa"
    ],
    "Phường 8": [
      "Phường Tân Hòa"
    ],
    "Phường 9": [
      "Phường Tân Hòa"
    ],
    "Phường 15": [
      "Phường Tân Sơn"
    ],
    "Phường 1": [
      "Phường Tân Sơn Hòa"
    ],
    "Phường 2": [
      "Phường Tân Sơn Hòa"
    ],
    "Phường 3": [
      "Phường Tân Sơn Hòa"
    ],
    "Phường 4": [
      "Phường Tân Sơn Nhất"
    ],
    "Phường 5": [
      "Phường Tân Sơn Nhất"
    ],
    "Phường 7": [
      "Phường Tân Sơn Nhất"
    ]
  },
  "Quận 4": {
    "Phường 8": [
      "Phường Khánh Hội"
    ],
    "Phường 9": [
      "Phường Khánh Hội"
    ],
    "Phường 15": [
      "Phường Khánh Hội"
    ],
    "Phường 1": [
      "Phường Vĩnh Hội"
    ],
    "Phường 3": [
      "Phường Vĩnh Hội"
    ],
    "Phường 2": [
      "Phường Vĩnh Hội"
    ],
    "Phường 4": [
      "Phường Vĩnh Hội"
    ],
    "Phường 13": [
      "Phường Xóm Chiếu"
    ],
    "Phường 16": [
      "Phường Xóm Chiếu"
    ],
    "Phường 18": [
      "Phường Xóm Chiếu"
    ],
    "Phường 10": [
      "Phường Khánh Hội"
    ],
    "Phường 6": [
      "Phường Khánh Hội"
    ],
    "Phường 14": [
      "Phường Khánh Hội"
    ]
  },
  "Thành phố Thủ Đức": {
    "Phường An Khánh": [
      "Phường An Khánh"
    ],
    "Phường An Lợi Đông": [
      "Phường An Khánh"
    ],
    "Phường Thảo Điền": [
      "Phường An Khánh"
    ],
    "Phường Thủ Thiêm": [
      "Phường An Khánh"
    ],
    "Phường Bình Trưng Đông": [
      "Phường Bình Trưng"
    ],
    "Phường Bình Trưng Tây": [
      "Phường Bình Trưng"
    ],
    "Phường An Phú": [
      "Phường Bình Trưng"
    ],
    "Phường Cát Lái": [
      "Phường Cát Lái"
    ],
    "Phường Thạnh Mỹ Lợi": [
      "Phường Cát Lái"
    ],
    "Phường Hiệp Bình Chánh": [
      "Phường Hiệp Bình"
    ],
    "Phường Hiệp Bình Phước": [
      "Phường Hiệp Bình"
    ],
    "Phường Linh Đông": [
      "Phường Hiệp Bình"
    ],
    "Phường Linh Trung": [
      "Phường Linh Xuân"
    ],
    "Phường Linh Xuân": [
      "Phường Linh Xuân"
    ],
    "Phường Linh Tây": [
      "Phường Linh Xuân"
    ],
    "Phường Long Bình": [
      "Phường Long Bình"
    ],
    "Phường Long Thạnh Mỹ": [
      "Phường Long Bình"
    ],
    "Phường Long Phước": [
      "Phường Long Phước"
    ],
    "Phường Trường Thạnh": [
      "Phường Long Phước"
    ],
    "Phường Long Trường": [
      "Phường Long Trường"
    ],
    "Phường Phú Hữu": [
      "Phường Long Trường"
    ],
    "Phường Phước Bình": [
      "Phường Phước Long"
    ],
    "Phường Phước Long A": [
      "Phường Phước Long"
    ],
    "Phường Phước Long B": [
      "Phường Phước Long"
    ],
    "Phường Bình Chiểu": [
      "Phường Tam Bình"
    ],
    "Phường Tam Bình": [
      "Phường Tam Bình"
    ],
    "Phường Tam Phú": [
      "Phường Tam Bình"
    ],
    "Phường Bình Thọ": [
      "Phường Thủ Đức"
    ],
    "Phường Linh Chiểu": [
      "Phường Thủ Đức"
    ],
    "Phường Trường Thọ": [
      "Phường Thủ Đức"
    ],
    "Phường Hiệp Phú": [
      "Phường Tăng Nhơn Phú"
    ],
    "Phường Tân Phú": [
      "Phường Tăng Nhơn Phú"
    ],
    "Phường Tăng Nhơn Phú A": [
      "Phường Tăng Nhơn Phú"
    ],
    "Phường Tăng Nhơn Phú B": [
      "Phường Tăng Nhơn Phú"
    ]
  },
  "Quận 12": {
    "Phường An Phú Đông": [
      "Phường An Phú Đông"
    ],
    "Phường Thạnh Lộc": [
      "Phường An Phú Đông"
    ],
    "Phường Thới An": [
      "Phường Thới An"
    ],
    "Phường Thạnh Xuân": [
      "Phường Thới An"
    ],
    "Phường Trung Mỹ Tây": [
      "Phường Trung Mỹ Tây"
    ],
    "Phường Tân Chánh Hiệp": [
      "Phường Trung Mỹ Tây"
    ],
    "Phường Hiệp Thành": [
      "Phường Tân Thới Hiệp"
    ],
    "Phường Tân Thới Hiệp": [
      "Phường Tân Thới Hiệp"
    ],
    "Phường Tân Thới Nhất": [
      "Phường Đông Hưng Thuận"
    ],
    "Phường Tân Hưng Thuận": [
      "Phường Đông Hưng Thuận"
    ],
    "Phường Đông Hưng Thuận": [
      "Phường Đông Hưng Thuận"
    ]
  },
  "Quận 5": {
    "Phường 5": [
      "Phường An Đông"
    ],
    "Phường 7": [
      "Phường An Đông"
    ],
    "Phường 9": [
      "Phường An Đông"
    ],
    "Phường 11": [
      "Phường Chợ Lớn"
    ],
    "Phường 12": [
      "Phường Chợ Lớn"
    ],
    "Phường 13": [
      "Phường Chợ Lớn"
    ],
    "Phường 14": [
      "Phường Chợ Lớn"
    ],
    "Phường 1": [
      "Phường Chợ Quán"
    ],
    "Phường 2": [
      "Phường Chợ Quán"
    ],
    "Phường 4": [
      "Phường Chợ Quán"
    ],
    "Phường 6": [
      "Phường An Đông"
    ],
    "Phường 8": [
      "Phường An Đông"
    ],
    "Phường 10": [
      "Phường Chợ Lớn"
    ],
    "Phường 3": [
      "Phường Chợ Quán"
    ]
  },
  "Quận 3": {
    "Phường 1": [
      "Phường Bàn Cờ"
    ],
    "Phường 2": [
      "Phường Bàn Cờ"
    ],
    "Phường 3": [
      "Phường Bàn Cờ"
    ],
    "Phường 5": [
      "Phường Bàn Cờ"
    ],
    "Phường 4": [
      "Phường Bàn Cờ"
    ],
    "Phường 9": [
      "Phường Nhiêu Lộc"
    ],
    "Phường 11": [
      "Phường Nhiêu Lộc"
    ],
    "Phường 12": [
      "Phường Nhiêu Lộc"
    ],
    "Phường 14": [
      "Phường Nhiêu Lộc"
    ],
    "Phường Võ Thị Sáu": [
      "Phường Xuân Hòa"
    ],
    "Phường 10": [
      "Phường Nhiêu Lộc"
    ],
    "Phường 13": [
      "Phường Nhiêu Lộc"
    ]
  },
  "Quận Bình Thạnh": {
    "Phường 5": [
      "Phường Bình Lợi Trung"
    ],
    "Phường 11": [
      "Phường Bình Lợi Trung"
    ],
    "Phường 13": [
      "Phường Bình Lợi Trung"
    ],
    "Phường 27": [
      "Phường Bình Quới"
    ],
    "Phường 28": [
      "Phường Bình Quới"
    ],
    "Phường 12": [
      "Phường Bình Thạnh"
    ],
    "Phường 14": [
      "Phường Bình Thạnh"
    ],
    "Phường 26": [
      "Phường Bình Thạnh"
    ],
    "Phường 1": [
      "Phường Gia Định"
    ],
    "Phường 2": [
      "Phường Gia Định"
    ],
    "Phường 7": [
      "Phường Gia Định"
    ],
    "Phường 17": [
      "Phường Gia Định"
    ],
    "Phường 19": [
      "Phường Thạnh Mỹ Tây"
    ],
    "Phường 22": [
      "Phường Thạnh Mỹ Tây"
    ],
    "Phường 25": [
      "Phường Thạnh Mỹ Tây"
    ],
    "Phường 6": [
      "Phường Bình Lợi Trung",
      "Phường Gia Định"
    ],
    "Phường 24": [
      "Phường Bình Thạnh"
    ],
    "Phường 3": [
      "Phường Gia Định"
    ],
    "Phường 15": [
      "Phường Gia Định"
    ],
    "Phường 21": [
      "Phường Thạnh Mỹ Tây"
    ]
  },
  "Quận 6": {
    "Phường 10": [
      "Phường Bình Phú"
    ],
    "Phường 11": [
      "Phường Bình Phú"
    ],
    "Phường 1": [
      "Phường Bình Tiên"
    ],
    "Phường 7": [
      "Phường Bình Tiên"
    ],
    "Phường 8": [
      "Phường Bình Tiên"
    ],
    "Phường 2": [
      "Phường Bình Tây"
    ],
    "Phường 9": [
      "Phường Bình Tây"
    ],
    "Phường 12": [
      "Phường Phú Lâm"
    ],
    "Phường 13": [
      "Phường Phú Lâm"
    ],
    "Phường 14": [
      "Phường Phú Lâm"
    ],
    "Phường 3": [
      "Phường Bình Tiên"
    ],
    "Phường 4": [
      "Phường Bình Tiên"
    ],
    "Phường 6": [
      "Phường Bình Tây"
    ],
    "Phường 5": [
      "Phường Bình Tây"
    ]
  },
  "Quận 11": {
    "Phường 3": [
      "Phường Bình Thới"
    ],
    "Phường 10": [
      "Phường Bình Thới"
    ],
    "Phường 8": [
      "Phường Bình Thới"
    ],
    "Phường 5": [
      "Phường Hòa Bình"
    ],
    "Phường 14": [
      "Phường Hòa Bình"
    ],
    "Phường 1": [
      "Phường Minh Phụng"
    ],
    "Phường 7": [
      "Phường Minh Phụng"
    ],
    "Phường 16": [
      "Phường Minh Phụng"
    ],
    "Phường 11": [
      "Phường Phú Thọ"
    ],
    "Phường 15": [
      "Phường Phú Thọ"
    ],
    "Phường 9": [
      "Phường Bình Thới"
    ],
    "Phường 12": [
      "Phường Bình Thới"
    ],
    "Phường 2": [
      "Phường Minh Phụng"
    ],
    "Phường 4": [
      "Phường Minh Phụng"
    ],
    "Phường 6": [
      "Phường Minh Phụng"
    ],
    "Phường 13": [
      "Phường Phú Thọ"
    ]
  },
  "Quận 8": {
    "Phường 6": [
      "Phường Bình Đông"
    ],
    "Phường 7": [
      "Phường Bình Đông"
    ],
    "Phường Rạch Ông": [
      "Phường Chánh Hưng"
    ],
    "Phường Hưng Phú": [
      "Phường Chánh Hưng"
    ],
    "Phường 4": [
      "Phường Chánh Hưng"
    ],
    "Phường 5": [
      "Phường Chánh Hưng"
    ],
    "Phường Xóm Củi": [
      "Phường Phú Định"
    ],
    "Phường 14": [
      "Phường Phú Định"
    ],
    "Phường 15": [
      "Phường Phú Định"
    ],
    "Phường 16": [
      "Phường Phú Định"
    ],
    "Phường 1": [
      "Phường Chánh Hưng"
    ],
    "Phường 2": [
      "Phường Chánh Hưng"
    ],
    "Phường 3": [
      "Phường Chánh Hưng"
    ],
    "Phường 8": [
      "Phường Chánh Hưng"
    ],
    "Phường 9": [
      "Phường Chánh Hưng"
    ],
    "Phường 10": [
      "Phường Chánh Hưng"
    ],
    "Phường 11": [
      "Phường Phú Định"
    ],
    "Phường 12": [
      "Phường Phú Định"
    ],
    "Phường 13": [
      "Phường Phú Định"
    ]
  },
  "Quận 1": {
    "Phường Bến Thành": [
      "Phường Bến Thành"
    ],
    "Phường Phạm Ngũ Lão": [
      "Phường Bến Thành"
    ],
    "Phường Nguyễn Thái Bình": [
      "Phường Bến Thành"
    ],
    "Phường Nguyễn Cư Trinh": [
      "Phường Cầu Ông Lãnh"
    ],
    "Phường Cầu Kho": [
      "Phường Cầu Ông Lãnh"
    ],
    "Phường Cô Giang": [
      "Phường Cầu Ông Lãnh"
    ],
    "Phường Cầu Ông Lãnh": [
      "Phường Cầu Ông Lãnh"
    ],
    "Phường Bến Nghé": [
      "Phường Sài Gòn"
    ],
    "Phường Tân Định": [
      "Phường Tân Định"
    ],
    "Phường Đa Kao": [
      "Phường Tân Định"
    ]
  },
  "Quận Phú Nhuận": {
    "Phường 1": [
      "Phường Cầu Kiệu"
    ],
    "Phường 2": [
      "Phường Cầu Kiệu"
    ],
    "Phường 7": [
      "Phường Cầu Kiệu"
    ],
    "Phường 15": [
      "Phường Cầu Kiệu"
    ],
    "Phường 8": [
      "Phường Phú Nhuận"
    ],
    "Phường 10": [
      "Phường Phú Nhuận"
    ],
    "Phường 11": [
      "Phường Phú Nhuận"
    ],
    "Phường 13": [
      "Phường Phú Nhuận"
    ],
    "Phường 4": [
      "Phường Đức Nhuận"
    ],
    "Phường 5": [
      "Phường Đức Nhuận"
    ],
    "Phường 9": [
      "Phường Đức Nhuận"
    ],
    "Phường 17": [
      "Phường Cầu Kiệu"
    ],
    "Phường 3": [
      "Phường Đức Nhuận"
    ]
  },
  "Quận 10": {
    "Phường 6": [
      "Phường Diên Hồng"
    ],
    "Phường 8": [
      "Phường Diên Hồng"
    ],
    "Phường 14": [
      "Phường Diên Hồng"
    ],
    "Phường 12": [
      "Phường Hòa Hưng"
    ],
    "Phường 13": [
      "Phường Hòa Hưng"
    ],
    "Phường 15": [
      "Phường Hòa Hưng"
    ],
    "Phường 1": [
      "Phường Vườn Lài"
    ],
    "Phường 2": [
      "Phường Vườn Lài"
    ],
    "Phường 4": [
      "Phường Vườn Lài"
    ],
    "Phường 9": [
      "Phường Vườn Lài"
    ],
    "Phường 10": [
      "Phường Vườn Lài"
    ],
    "Phường 7": [
      "Phường Diên Hồng"
    ],
    "Phường 5": [
      "Phường Diên Hồng"
    ],
    "Phường 11": [
      "Phường Vườn Lài"
    ]
  },
  "Quận 7": {
    "Phường Phú Thuận": [
      "Phường Phú Thuận"
    ],
    "Phường Tân Phong": [
      "Phường Tân Hưng"
    ],
    "Phường Tân Hưng": [
      "Phường Tân Hưng"
    ],
    "Phường Tân Kiểng": [
      "Phường Tân Hưng"
    ],
    "Phường Tân Quy": [
      "Phường Tân Hưng"
    ],
    "Phường Tân Phú": [
      "Phường Tân Mỹ"
    ],
    "Phường Phú Mỹ": [
      "Phường Tân Mỹ"
    ],
    "Phường Bình Thuận": [
      "Phường Tân Thuận"
    ],
    "Phường Tân Thuận Đông": [
      "Phường Tân Thuận"
    ],
    "Phường Tân Thuận Tây": [
      "Phường Tân Thuận"
    ]
  },
  "Quận Tân Phú": {
    "Phường Phú Thạnh": [
      "Phường Phú Thạnh"
    ],
    "Phường Hiệp Tân": [
      "Phường Phú Thạnh"
    ],
    "Phường Tân Thới Hòa": [
      "Phường Phú Thạnh"
    ],
    "Phường Phú Thọ Hòa": [
      "Phường Phú Thọ Hòa"
    ],
    "Phường Tân Thành": [
      "Phường Phú Thọ Hòa"
    ],
    "Phường Phú Trung": [
      "Phường Tân Phú"
    ],
    "Phường Hòa Thạnh": [
      "Phường Tân Phú"
    ],
    "Phường Tân Sơn Nhì": [
      "Phường Tân Sơn Nhì"
    ],
    "Phường Sơn Kỳ": [
      "Phường Tân Sơn Nhì"
    ],
    "Phường Tân Quý": [
      "Phường Tân Sơn Nhì"
    ],
    "Phường Tây Thạnh": [
      "Phường Tây Thạnh"
    ]
  },
  "Huyện Củ Chi": {
    "Xã Phú Mỹ Hưng": [
      "Xã An Nhơn Tây"
    ],
    "Xã An Phú": [
      "Xã An Nhơn Tây"
    ],
    "Xã An Nhơn Tây": [
      "Xã An Nhơn Tây"
    ],
    "Xã Bình Mỹ": [
      "Xã Bình Mỹ"
    ],
    "Xã Trung An": [
      "Xã Bình Mỹ"
    ],
    "Xã Hòa Phú": [
      "Xã Bình Mỹ"
    ],
    "Xã Tân Phú Trung": [
      "Xã Củ Chi"
    ],
    "Xã Tân Thông Hội": [
      "Xã Củ Chi"
    ],
    "Xã Phước Vĩnh An": [
      "Xã Củ Chi"
    ],
    "Xã Nhuận Đức": [
      "Xã Nhuận Đức"
    ],
    "Xã Trung Lập Hạ": [
      "Xã Nhuận Đức"
    ],
    "Xã Phạm Văn Cội": [
      "Xã Nhuận Đức"
    ],
    "Xã Tân Thạnh Tây": [
      "Xã Phú Hòa Đông"
    ],
    "Xã Tân Thạnh Đông": [
      "Xã Phú Hòa Đông"
    ],
    "Xã Phú Hòa Đông": [
      "Xã Phú Hòa Đông"
    ],
    "Xã Trung Lập Thượng": [
      "Xã Thái Mỹ"
    ],
    "Xã Thái Mỹ": [
      "Xã Thái Mỹ"
    ],
    "Xã Phước Thạnh": [
      "Xã Thái Mỹ"
    ],
    "Xã Phước Hiệp": [
      "Xã Tân An Hội"
    ],
    "Xã Tân An Hội": [
      "Xã Tân An Hội"
    ],
    "Thị trấn Củ Chi": [
      "Xã Tân An Hội"
    ]
  },
  "Huyện Cần Giờ": {
    "Xã Lý Nhơn": [
      "Xã An Thới Đông"
    ],
    "Xã An Thới Đông": [
      "Xã An Thới Đông"
    ],
    "Xã Bình Khánh": [
      "Xã Bình Khánh"
    ],
    "Xã Tam Thôn Hiệp": [
      "Xã Bình Khánh"
    ],
    "Xã Long Hòa": [
      "Xã Cần Giờ"
    ],
    "Thị trấn Cần Thạnh": [
      "Xã Cần Giờ"
    ],
    "Xã Thạnh An": [
      "Xã Thạnh An"
    ]
  },
  "Huyện Hóc Môn": {
    "Xã Xuân Thới Thượng": [
      "Xã Bà Điểm"
    ],
    "Xã Bà Điểm": [
      "Xã Bà Điểm"
    ],
    "Xã Trung Chánh": [
      "Xã Bà Điểm"
    ],
    "Xã Tân Xuân": [
      "Xã Hóc Môn"
    ],
    "Xã Tân Hiệp": [
      "Xã Hóc Môn"
    ],
    "Thị trấn Hóc Môn": [
      "Xã Hóc Môn"
    ],
    "Xã Xuân Thới Đông": [
      "Xã Xuân Thới Sơn"
    ],
    "Xã Xuân Thới Sơn": [
      "Xã Xuân Thới Sơn"
    ],
    "Xã Tân Thới Nhì": [
      "Xã Xuân Thới Sơn"
    ],
    "Xã Đông Thạnh": [
      "Xã Đông Thạnh"
    ],
    "Xã Nhị Bình": [
      "Xã Đông Thạnh"
    ],
    "Xã Thới Tam Thôn": [
      "Xã Đông Thạnh"
    ]
  },
  "Huyện Bình Chánh": {
    "Xã Bình Chánh": [
      "Xã Bình Chánh"
    ],
    "Xã Tân Quý Tây": [
      "Xã Bình Chánh"
    ],
    "Xã An Phú Tây": [
      "Xã Bình Chánh"
    ],
    "Xã Bình Hưng": [
      "Xã Bình Hưng"
    ],
    "Xã Phong Phú": [
      "Xã Bình Hưng"
    ],
    "Xã Bình Lợi": [
      "Xã Bình Lợi"
    ],
    "Xã Lê Minh Xuân": [
      "Xã Bình Lợi"
    ],
    "Xã Hưng Long": [
      "Xã Hưng Long"
    ],
    "Xã Quy Đức": [
      "Xã Hưng Long"
    ],
    "Xã Đa Phước": [
      "Xã Hưng Long"
    ],
    "Xã Tân Nhựt": [
      "Xã Tân Nhựt"
    ],
    "Thị trấn Tân Túc": [
      "Xã Tân Nhựt"
    ],
    "Xã Tân Kiên": [
      "Xã Tân Nhựt"
    ],
    "Xã Vĩnh Lộc B": [
      "Xã Tân Vĩnh Lộc"
    ],
    "Xã Phạm Văn Hai": [
      "Xã Tân Vĩnh Lộc"
    ],
    "Xã Vĩnh Lộc A": [
      "Xã Vĩnh Lộc"
    ]
  },
  "Huyện Nhà Bè": {
    "Xã Nhơn Đức": [
      "Xã Hiệp Phước"
    ],
    "Xã Long Thới": [
      "Xã Hiệp Phước"
    ],
    "Xã Hiệp Phước": [
      "Xã Hiệp Phước"
    ],
    "Thị trấn Nhà Bè": [
      "Xã Nhà Bè"
    ],
    "Xã Phú Xuân": [
      "Xã Nhà Bè"
    ],
    "Xã Phước Kiển": [
      "Xã Nhà Bè"
    ],
    "Xã Phước Lộc": [
      "Xã Nhà Bè"
    ]
  }
};

export default hcmWardMappings;
